import React from 'react'
import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper'
import { pointExpirationJsonSchema, pointExpirationUiSchema } from '@/services/schema/activity'

const PointExpirationSetUp = ({ formData, handleFormChange }) => {
  
  return (
    <div className="flex flex-col w-full" data-testid="point-expiration-setup">
      <div className="min-w-[288px]">
        <JsonFormsWrapper
          jsonschema={pointExpirationJsonSchema}
          uischema={pointExpirationUiSchema}
          data={formData}
          onChange={handleFormChange}
        />
      </div>
      
      <div className="mt-2">
        <div className="text-sm font-medium">
          <span className="mr-1">Preview:</span>
          <span className="preview-value">
            Points expire after <span className="font-bold">{formData.noOfDays || '0'}</span> days
          </span>
        </div>
      </div>
    </div>
  )
}

export default PointExpirationSetUp
